<template>
    <div>
        <!-- test2 -->
        <v-container fluid>
            <v-row>
                <v-col :cols="6">
                    <h1 class="headline font-weight-light mb-3">
                        Application develop request form
                    </h1>
                </v-col>
                <v-col :cols="3">
                    <v-menu
                        ref="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="dateRangeText"
                                label="Date range"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="filter_date.date"
                            range
                            @change="search_date"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col :cols="3">
                    <v-text-field
                        label="search"
                        v-model="filter_search"
                        clearable
                        @keydown="search_text"
                    >
                    </v-text-field>
                </v-col>
            </v-row>
        </v-container>

        <v-form ref="form" method="post" id="nativeForm" v-model="valid">
            <v-dialog v-model="dialog" max-width="1000px">
                <v-card>
                    <v-card-title>
                        <label class="headline" style="text-align: left">{{
                            formTitle
                        }}</label>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col md="4" sm="12" xs="12">
                                    <v-menu
                                        ref="menu"
                                        :close-on-content-click="true"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-text-field
                                                v-model="request_date"
                                                label="Request Date"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                :rules="[
                                                    (v) =>
                                                        !!v || 'Date required',
                                                ]"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="request_date"
                                            no-title
                                            scrollable
                                        >
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col md="8" sm="12" xs="12">
                                    <v-autocomplete
                                        :rules="[
                                            (v) => !!v || 'Request By required',
                                        ]"
                                        v-model="request_by"
                                        :items="employee"
                                        item-text="emp_name_en"
                                        item-value="emp_id"
                                        chips
                                        small-chips
                                        label="Request By"
                                        multiple
                                    >
                                        <template v-slot:item="data">
                                            <template>
                                                <v-list-item-content
                                                    v-text="
                                                        data.item.emp_name_en +
                                                            ' ' +
                                                            data.item
                                                                .emp_surname_en
                                                    "
                                                ></v-list-item-content>
                                            </template>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="12" sm="12" xs="12">
                                    <v-text-field
                                        :rules="[
                                            (v) => !!v || 'Title required',
                                        ]"
                                        v-model="request_title"
                                        label="Title"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-alert outlined type="warning" text>
                                <center>System Requirement</center>
                            </v-alert>
                            <v-row
                                v-for="(item, idx) in request_requirement"
                                :key="idx"
                            >
                                <v-col cols="6">
                                    <v-textarea
                                        :rules="[
                                            (v) => !!v || 'Detail required',
                                        ]"
                                        v-model="item.detail"
                                        label="Detail "
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="6">
                                    <v-textarea
                                        :rules="[
                                            (v) =>
                                                !!v ||
                                                'Security / Permission required',
                                        ]"
                                        v-model="item.security"
                                        label="Security / Permission"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" class="text-center">
                                    <v-btn
                                        class="mx-2"
                                        fab
                                        @click="add_requirement()"
                                        dark
                                        small
                                        color="primary"
                                        v-if="
                                            idx + 1 ==
                                                request_requirement.length
                                        "
                                    >
                                        <v-icon dark> mdi-plus-circle </v-icon>
                                    </v-btn>
                                    <v-btn
                                        class="mx-2"
                                        fab
                                        dark
                                        @click="remove_requirement()"
                                        small
                                        color="red"
                                        v-if="
                                            idx + 1 ==
                                                request_requirement.length &&
                                                idx != 0
                                        "
                                    >
                                        <v-icon dark> mdi-delete </v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="grey darken-1"
                            dark
                            small
                            @click="close_request"
                            rounded
                            >Cancel</v-btn
                        >
                        <v-btn
                            color="blue darken-1"
                            dark
                            small
                            @click="save_request"
                            rounded
                            >Save</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-form>

        <v-dialog v-model="viewitem_dialog" max-width="1000px">
            <v-card>
                <v-card-title>
                    <label class="headline" style="text-align: left"
                        >DEV NO : {{ viewitem.dev_id }}</label
                    >
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="4">
                                <b>Request : </b
                                >{{ viewitem.request_date_show }}
                            </v-col>
                            <v-col cols="8">
                                <p
                                    v-for="(item, idx) in viewitem.request"
                                    :key="idx"
                                >
                                    {{ item.emp_name_en }}
                                    {{ item.emp_surname_en }}
                                </p>
                            </v-col>
                        </v-row>
                        <v-row v-if="viewitem.status == 'Not Approved'">
                            <v-col cols="6">
                                <b>Not Approved By : </b>
                                {{ viewitem.approved_name }}
                                {{ viewitem.approved_date }}
                            </v-col>
                            <v-col cols="6">
                                <b>Reason : </b>{{ viewitem.remark }}
                            </v-col>
                        </v-row>
                        <v-row v-if="viewitem.status == 'Delete'">
                            <v-col cols="6">
                                <b>Deleted By : </b>
                                {{ viewitem.deleted_name }}
                                {{ viewitem.deleted_date }}
                            </v-col>
                            <v-col cols="6">
                                <b>Reason : </b>{{ viewitem.remark }}
                            </v-col>
                        </v-row>
                        <v-row
                            v-if="
                                viewitem.status != 'Not Approved' &&
                                    viewitem.status != 'Request' &&
                                    viewitem.status != 'Delete'
                            "
                        >
                            <v-col cols="4">
                                <b>Approved : </b>{{ viewitem.approved_date }}
                            </v-col>
                            <v-col cols="8">
                                <p>
                                    {{ viewitem.approved_name }}
                                </p>
                            </v-col>
                        </v-row>
                        <v-row v-if="viewitem.dev_start_date_show">
                            <v-col cols="6">
                                <b>Development : </b>
                                {{ viewitem.dev_start_date_show }}
                                ~
                                {{ viewitem.dev_end_date_show }}
                            </v-col>
                            <v-col cols="12">
                                {{ viewitem.dev_remark }}
                            </v-col>
                        </v-row>
                        <v-row v-if="viewitem.status == 'Closed'">
                            <v-col cols="6">
                                <b>Closed : </b>
                                {{ viewitem.closed_date }}
                                {{ viewitem.closed_name }}
                            </v-col>
                            <v-col cols="6">
                                <b>Deploy Version : </b
                                >{{ viewitem.deploy_version }}
                                {{ viewitem.deploy_date_show }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <span class="headline">{{
                                    viewitem.title
                                }}</span>
                            </v-col>
                        </v-row>
                        <v-alert outlined type="warning" text>
                            <center>System Requirement</center>
                        </v-alert>
                        <v-row
                            v-for="(item, idx) in viewitem.requirement"
                            :key="idx"
                        >
                            <v-col cols="1"> {{ idx + 1 }}). </v-col>
                            <v-col cols="5">
                                {{ item.detail }}
                            </v-col>
                            <v-col cols="6">
                                {{ item.security }}
                            </v-col>
                        </v-row>

                        <v-alert outlined type="primary" text>
                            <center>Test Cases</center>
                        </v-alert>
                        <v-tabs
                            v-if="viewitem.test_round"
                            v-model="active_tab"
                            background-color="primary lighten-2"
                        >
                            <v-tab
                                v-for="i in parseInt(viewitem.test_round)"
                                :key="i"
                            >
                                #{{ i }}
                            </v-tab>
                            <v-tab-item
                                v-for="i in parseInt(viewitem.test_round)"
                                :key="i"
                            >
                                <v-card-text class="pa-2">
                                    <v-row
                                        v-for="(item, idx) in viewitem.test"
                                        :key="idx"
                                    >
                                        <v-col cols="4" v-if="item.round == i">
                                            <b>Detail : </b>{{ item.detail }}
                                            <br />
                                            <b>Security : </b
                                            >{{ item.security }}
                                        </v-col>
                                        <v-col cols="4" v-if="item.round == i">
                                            <v-icon
                                                v-if="
                                                    item.test_group ==
                                                        'developer'
                                                "
                                                >mdi-dev-to</v-icon
                                            >
                                            <v-icon v-else
                                                >mdi-account-circle</v-icon
                                            >

                                            {{ item.test_name }}
                                            <br />
                                            {{ item.test_date }}
                                        </v-col>
                                        <v-col cols="4" v-if="item.round == i">
                                            {{ item.test_status }} -
                                            {{ item.test_remark }}
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-tab-item>
                        </v-tabs>

                        <!-- Approve -->
                        <v-row v-if="viewitem.status == 'Request'">
                            <v-col cols="6">
                                <v-radio-group
                                    v-model="viewitem.approve_status"
                                    row
                                >
                                    <v-radio
                                        label="Approved"
                                        value="Y"
                                    ></v-radio>
                                    <v-radio
                                        label="Not Approved"
                                        value="N"
                                    ></v-radio>
                                </v-radio-group>
                            </v-col>
                            <v-col
                                cols="12"
                                v-if="viewitem.approve_status == 'N'"
                            >
                                <v-text-field
                                    v-model="viewitem.remark"
                                    label="Remark"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <!-- End Approve -->

                        <!-- On Dev -->
                        <v-row
                            v-if="
                                viewitem.status == 'Approved' &&
                                    team_name == 'PROGRAMMER'
                            "
                        >
                            <v-col cols="6">
                                <v-menu
                                    ref="menu"
                                    :close-on-content-click="true"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dev_start_date"
                                            label="Expected Start Dev. Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="dev_start_date"
                                        no-title
                                        scrollable
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="6">
                                <v-menu
                                    ref="menu"
                                    :close-on-content-click="true"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dev_end_date"
                                            label="Expected End Dev. Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="dev_end_date"
                                        no-title
                                        scrollable
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="dev_remark"
                                    label="Remark"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                        <!-- END On Dev -->

                        <!-- Wait Deploy -->
                        <v-row
                            v-if="
                                viewitem.status == 'Wait Deploy' &&
                                    team_name == 'PROGRAMMER'
                            "
                        >
                            <v-col cols="6">
                                <v-menu
                                    ref="menu"
                                    :close-on-content-click="true"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="deploy_date"
                                            label="Deploy Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="deploy_date"
                                        no-title
                                        scrollable
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field
                                    v-model="deploy_version"
                                    label="Deploy Version."
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <!-- END Wait Deploy -->
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        dark
                        color="grey lighten-1"
                        @click="close_detail"
                        rounded
                        >Close</v-btn
                    >
                    <v-btn
                        v-if="viewitem.status == 'Request'"
                        small
                        dark
                        color="blue darken-1"
                        @click="save_approve"
                        rounded
                        >Save</v-btn
                    >
                    <v-btn
                        v-if="viewitem.status == 'Approved'"
                        small
                        dark
                        color="green darken-1"
                        @click="save_update(viewitem.dev_id)"
                        rounded
                        >Update</v-btn
                    >

                    <v-btn
                        v-if="viewitem.status == 'Wait Deploy'"
                        small
                        dark
                        color="green darken-1"
                        @click="save_deploy(viewitem.dev_id)"
                        rounded
                        >Deploy</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="testitem_dialog" max-width="1000px">
            <v-card>
                <v-card-title>
                    <label class="headline" style="text-align: left"
                        >DEV NO : {{ testitem.dev_id }}</label
                    >
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="4">
                                <b>Request : </b
                                >{{ testitem.request_date_show }}
                            </v-col>
                            <v-col cols="8">
                                <p
                                    v-for="(item, idx) in testitem.request"
                                    :key="idx"
                                >
                                    {{ item.emp_name_en }}
                                    {{ item.emp_surname_en }}
                                </p>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <b>Approved : </b>{{ testitem.approved_date }}
                            </v-col>
                            <v-col cols="8">
                                <p>
                                    {{ testitem.approved_name }}
                                </p>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <b>Development : </b>
                                {{ testitem.dev_start_date_show }}
                                ~
                                {{ testitem.dev_end_date_show }}
                            </v-col>
                            <v-col cols="12">
                                {{ testitem.dev_remark }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <span class="headline">{{
                                    testitem.title
                                }}</span>
                            </v-col>
                        </v-row>
                        <v-alert outlined type="primary" text>
                            <center>
                                #{{ parseInt(testitem.test_round) + 1 }} TEST
                                CASES
                            </center>
                        </v-alert>
                        <v-row
                            v-for="(item, idx) in testitem.requirement"
                            :key="idx"
                        >
                            <v-col cols="1"> {{ idx + 1 }}). </v-col>
                            <v-col cols="5">
                                {{ item.detail }}
                            </v-col>
                            <v-col cols="6">
                                {{ item.security }}
                            </v-col>
                            <v-col cols="12">
                                <v-container>
                                    <v-row>
                                        <v-radio-group
                                            v-model="item.test_status"
                                            row
                                        >
                                            <v-radio
                                                label="Passed"
                                                value="Y"
                                            ></v-radio>
                                            <v-radio
                                                label="Not Passed"
                                                value="N"
                                            ></v-radio>
                                        </v-radio-group>
                                        <v-text-field
                                            v-if="item.test_status == 'N'"
                                            v-model="item.test_remark"
                                            label="Remark"
                                        ></v-text-field>
                                    </v-row>
                                </v-container>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        dark
                        color="grey lighten-1"
                        @click="close_detail"
                        rounded
                        >Close</v-btn
                    >
                    <v-btn
                        small
                        dark
                        color="purple darken-1"
                        @click="save_test"
                        rounded
                        >Save Test</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-card>
            <v-card-title>
                <v-chip-group mandatory active-class="primary--text">
                    <v-chip
                        v-for="(item, idx) in status"
                        :key="idx"
                        @click="search_status(item)"
                    >
                        {{ item }}
                    </v-chip>
                </v-chip-group>
                <v-spacer></v-spacer>
                <v-btn
                    small
                    color="primary"
                    dark
                    class="mb-2"
                    @click="new_request()"
                    >Create New</v-btn
                >
            </v-card-title>

            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-center">
                                <b>#</b>
                            </th>
                            <th class="text-center">
                                <b>Request Date</b>
                            </th>
                            <th class="text-center">
                                <b>Status</b>
                            </th>
                            <th class="text-center">
                                <b>Detail</b>
                            </th>
                            <th class="text-center"><b>Action</b></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in data" :key="idx">
                            <td class="text-center">{{ item.dev_id }}</td>
                            <td class="text-center">
                                {{ item.request_date_show }}
                            </td>
                            <td class="text-center">{{ item.status }}</td>
                            <td>{{ item.title }}</td>
                            <td class="text-center">
                                <v-btn
                                    class="white--text mr-1 ml-1"
                                    color="warning"
                                    depressed
                                    x-small
                                    @click="edit_detail(item.dev_id)"
                                    v-if="
                                        item.status == 'Request' ||
                                            item.status == 'Not Approved'
                                    "
                                >
                                    <v-icon dark small>mdi-account-edit</v-icon>
                                    Edit
                                </v-btn>
                                <v-btn
                                    class="white--text mr-1 ml-1"
                                    color="purple"
                                    depressed
                                    x-small
                                    @click="view_test(item.dev_id, 'developer')"
                                    v-if="
                                        item.status == 'On Dev' &&
                                            team_name == 'PROGRAMMER'
                                    "
                                >
                                    <v-icon dark small>mdi-account-edit</v-icon>
                                    Test
                                </v-btn>
                                <v-btn
                                    class="white--text mr-1 ml-1"
                                    color="purple"
                                    depressed
                                    x-small
                                    @click="view_test(item.dev_id, 'users')"
                                    v-if="
                                        item.status == 'Testing' &&
                                            team_name != 'PROGRAMMER'
                                    "
                                >
                                    <v-icon dark small>mdi-account-edit</v-icon>
                                    Test
                                </v-btn>
                                <v-btn
                                    class="white--text mr-1 ml-1"
                                    color="primary"
                                    depressed
                                    x-small
                                    @click="view_detail(item.dev_id)"
                                >
                                    <v-icon dark small>mdi-eye</v-icon>
                                    View
                                </v-btn>
                                <v-btn
                                    class="white--text mr-1 ml-1"
                                    color="error"
                                    depressed
                                    x-small
                                    v-if="
                                        item.status == 'Request' ||
                                            item.status == 'Not Approved'
                                    "
                                    @click="delete_request(item.dev_id)"
                                >
                                    <v-icon dark small>mdi-delete</v-icon>
                                    Delete
                                </v-btn>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-card>
    </div>
</template>

<script>
import axios from "axios"
export default {
    computed: {
        formTitle() {
            return this.request_no == ""
                ? "Create new request"
                : "Edit request " + this.request_no
        },
        dateRangeText() {
            this.filter_date.date.sort((a, b) => {
                return new Date(a) - new Date(b)
            })
            return this.filter_date.date.join(" ~ ")
        },
    },
    created() {
        this.search_text = _.debounce(this.search_text, 1000)
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_employee()
        this.get_data()
    },
    data() {
        return {
            status: [
                "All",
                "Request",
                "Not Approved",
                "Approved",
                "On Dev",
                "Testing",
                "Wait Deploy",
            ],
            filter_search: "",
            filter_status: "",
            tk: {},
            employee: [],
            team_name: localStorage.team_name,
            request_no: "",
            request_by: [],
            request_date: new Date().toISOString().substr(0, 10),
            request_title: "",
            request_requirement: [{ detail: "", security: "" }],
            dialog: false,
            viewitem_dialog: false,
            testitem_dialog: false,
            data: [],
            viewitem: {},
            dev_remark: "",
            dev_start_date: "",
            dev_end_date: "",
            testitem: {},
            test_by: "",
            active_tab: 0,
            deploy_date: "",
            deploy_version: "",
            filter_date: {
                date: [],
                // date: [
                //     new Date().toISOString().substr(0, 10),
                //     new Date().toISOString().substr(0, 10),
                // ],
            },
        }
    },

    methods: {
        async get_employee() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/employees`
            const datasend = {
                branch_id: "",
                att_range_id: "",
                cost_center_id: "",
                department_id: "",
                position_id: "",
                search: "",
            }
            try {
                const { data } = await axios.post(url, datasend)
                // console.log(data)
                this.employee = data
            } catch (error) {
                console.log(error)
            }
        },
        search_text() {
            this.get_data()
        },
        search_date() {
            if (this.dateRangeText.length === 23) {
                this.get_data()
            }
        },
        search_status(status) {
            this.filter_status = status == "All" ? "" : status
            this.get_data()
        },
        async get_data() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/dev`
            const datasend = {
                search: this.filter_search,
                status: this.filter_status,
                date: this.filter_date.date,
            }
            try {
                const { data } = await axios.post(url, datasend, this.tk)
                this.data = data
            } catch (error) {
                console.log(error)
            }
        },
        add_requirement() {
            this.request_requirement.push({
                detail: "",
                security: "",
            })
        },
        remove_requirement() {
            const index = this.request_requirement.indexOf(
                this.request_requirement.length
            )
            this.request_requirement.splice(index, 1)
        },
        new_request() {
            this.reset_request()
            this.dialog = true
            this.$refs.form.validate()
        },
        close_request() {
            this.dialog = false
            this.reset_request()
        },
        reset_request() {
            this.request_no = ""
            this.request_date = new Date().toISOString().substr(0, 10)
            this.request_by = []
            this.request_title = ""
            this.request_requirement = [{ detail: "", security: "" }]
        },
        async save_request() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/dev/new-request`
            const datasend = {
                request_no: this.request_no,
                request_date: this.request_date,
                request_by: this.request_by,
                request_title: this.request_title,
                request_requirement: this.request_requirement,
            }
            try {
                const { data } = await axios.post(url, datasend, this.tk)
                this.close_request()
                this.get_data()
            } catch (error) {
                console.log(error)
            }
        },
        async view_detail(dev_id) {
            const url = `${process.env.VUE_APP_ROOT_API}/api/dev/${dev_id}`
            try {
                const { data } = await axios.get(url, this.tk)
                this.viewitem = data
                this.viewitem_dialog = true
            } catch (error) {
                console.log(error)
            }
        },
        async save_approve() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/dev/save-approve/${this.viewitem.dev_id}`
            const datasend = { ...this.viewitem }
            try {
                const { data } = await axios.post(url, datasend, this.tk)
                this.close_detail()
                this.get_data()
            } catch (error) {
                console.log(error)
            }
        },
        close_detail() {
            this.viewitem_dialog = false
            this.viewitem = {}
            this.dev_remark = ""
            this.dev_start_date = ""
            this.dev_end_date = ""
            this.deploy_date = ""
            this.deploy_version = ""
        },
        async save_reapprove() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/dev/save-reapprove/${this.viewitem.dev_id}`
            const datasend = { ...this.viewitem }
            try {
                const { data } = await axios.post(url, datasend, this.tk)
                this.close_detail()
                this.get_data()
            } catch (error) {
                console.log(error)
            }
        },
        async edit_detail(dev_id) {
            const url = `${process.env.VUE_APP_ROOT_API}/api/dev/${dev_id}`
            try {
                const { data } = await axios.get(url, this.tk)
                // console.log(data, "sohwdhahara");
                this.request_no = dev_id
                this.request_date = data.request_date
                this.request_title = data.title
                this.request_requirement = [...data.requirement]
                this.request_by = []

                data.request.forEach((each) => {
                    this.request_by.push(each.emp_id)
                })
                this.dialog = true
            } catch (error) {
                console.log(error)
            }
        },
        delete_request(dev_id) {
            this.$swal({
                title: `Are you sure to delete ${dev_id} ?`,
                icon: "warning",
                buttons: true,
                content: "input",
                inputPlaceholder: "Reason",
                showCancelButton: true,
                closeOnConfirm: false,
            }).then((result) => {
                if (result !== null) {
                    if (result === "") {
                        this.$swal({
                            title: `You have to write something !`,
                            icon: "error",
                        })
                        return false
                    }
                    const url = `${process.env.VUE_APP_ROOT_API}/api/dev/delete/${dev_id}`
                    try {
                        const { data } = axios.post(
                            url,
                            { remark: result },
                            this.tk
                        )
                        this.get_data()
                    } catch (error) {
                        console.log(error)
                    }
                }
            })
        },
        async save_update(dev_id) {
            const url = `${process.env.VUE_APP_ROOT_API}/api/dev/save-update/${dev_id}`
            const datasend = {
                dev_remark: this.dev_remark,
                dev_end_date: this.dev_end_date,
                dev_start_date: this.dev_start_date,
            }
            try {
                const { data } = await axios.post(url, datasend, this.tk)
                this.close_detail()
                this.get_data()
            } catch (error) {
                console.log(error)
            }
        },
        async view_test(dev_id, test_by) {
            const url = `${process.env.VUE_APP_ROOT_API}/api/dev/${dev_id}`
            try {
                const { data } = await axios.get(url, this.tk)
                this.testitem = data
                this.test_by = test_by
                this.testitem_dialog = true
            } catch (error) {
                console.log(error)
            }
        },
        async save_test() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/dev/save-test/${this.testitem.dev_id}`
            const datasend = {
                test_case: this.testitem.requirement,
                test_round: this.testitem.test_round,
                test_by: this.test_by,
            }
            try {
                const { data } = await axios.post(url, datasend, this.tk)
                this.close_test()
                this.get_data()
            } catch (error) {
                console.log(error)
            }
        },
        close_test() {
            this.testitem_dialog = false
            this.testitem = {}
            this.test_by = ""
        },
        async save_deploy(dev_id) {
            const url = `${process.env.VUE_APP_ROOT_API}/api/dev/save-deploy/${dev_id}`
            const datasend = {
                deploy_date: this.deploy_date,
                deploy_version: this.deploy_version,
            }
            try {
                const { data } = await axios.post(url, datasend, this.tk)
                this.close_detail()
                this.get_data()
            } catch (error) {
                console.log(error)
            }
        },
    },
}
</script>
